import { createSelector } from 'reselect';

const selectFormularioRespostaProcessoState = (state) => state.formularioRespostaProcesso;

export const makeSelectFormularioRespostaBySolicitacao = (idProcesso, idSolicitacao) =>
  createSelector(
    [selectFormularioRespostaProcessoState],
    (state) => {
      const key = `${idProcesso}-${idSolicitacao}`;
      return state.respostas[key] || null;
    }
  );
